import { loadLegalDocumentActions } from '@/redux/actions/service-directory/legal-document';
import { LegalDocumentType } from '@/types';
import { createReducer } from 'deox';

export type LegalDocumentState = Record<LegalDocumentType, string>;

const initialState = {} as LegalDocumentState;

const htmlsReducer = createReducer(initialState, (handleAction) => [
  handleAction(loadLegalDocumentActions.success, (state, { payload }) => ({
    ...state,
    [payload.legalDocumentType]: payload.html,
  })),
]);

export default htmlsReducer;
